import { FC } from 'react'
import SvgStatusCritical from './icons/status-critical'
import SvgStatusImportant from './icons/status-important'
import SvgStatusModerate from './icons/status-moderate'
import SvgStatusInReview from './icons/status-in-review'
import SvgStatusApproved from './icons/status-approved'
import SvgStatusResolved from '@routes/issues/components/pdfIssues/icons/status-resolved'

type SeverityIconProps = {
    severity: TIssueSeverity | TIssueStatus
}

export const SeverityIcon: FC<SeverityIconProps> = ({ severity }) => {
    if (severity === 'critical') {
        return <SvgStatusCritical />
    }
    if (severity === 'important') {
        return <SvgStatusImportant />
    }
    if (severity === 'moderate') {
        return <SvgStatusModerate />
    }
    if (severity === 'clean') {
        return <SvgStatusResolved />
    }
    if (severity === 'in_review') {
        return <SvgStatusInReview />
    }
    if (severity === 'approved') {
        return <SvgStatusApproved />
    }
    if (severity === 'resolved') {
        return <SvgStatusResolved />
    }
    return null
}
